module.exports = __webpack_public_path__ + "img/mail.64ab9925.svg";